import { createAction } from '@reduxjs/toolkit';

export const addToCart = createAction<{ sku: string, quantity: number, productName?: string, reference? :string }>('addToCart');
export const addToCartFulfilled = createAction<{ sku: string, quantity: number }>('addToCartFulfilled');
export const addToCartRejected = createAction<{ sku: string, quantity: number }>('addToCartRejected');
